import type { Mouvement } from '@mairistem/comptabilite';
import ActionResultType from '../../../../interfaces/pieces/ActionResultType';
import type { BaseLiquidationOptions } from '../../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import MouvementActionType from '../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type TreeviewActionResult from '../../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../../pieces/BaseLiquidationAction';

class MouvementModifierAction extends BaseLiquidationAction<
	Mouvement,
	MouvementActionType
> {
	isReadonly: boolean;

	constructor(
		options: BaseLiquidationOptions & { isReadonly?: boolean } = null,
	) {
		super(options);
		this.isReadonly = options?.isReadonly;
		this.label = options?.isReadonly ? 'Afficher' : 'Modifier';
		this.type = options?.isReadonly
			? MouvementActionType.SHOW_MOUVEMENT
			: MouvementActionType.UPDATE_MOUVEMENT;
	}

	execute = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
		type: ActionResultType.LINK,
		result: Promise.resolve(mouvement),
		extraProps: {
			link: {
				typeAction: this.type,
				readonly: this.isReadonly,
			},
		},
	});
}

export default MouvementModifierAction;
